import { Loader } from '@/components/shared';
import { WizardLayout } from '../layout';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useQuotePrefill } from '../hooks/useQuotePrefill';

interface IWizardProps {
  isLogged?: boolean;
}

export const Wizard: React.FC<IWizardProps> = (props): JSX.Element => {
  const { isLoading } = useQuotePrefill();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <WizardLayout {...props}>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </WizardLayout>
  );
};
